module.exports = __webpack_public_path__ + "static/media/keys_addresses_wallets_bitcoin-studio.372eb9fb.jpg";